module.exports = __webpack_public_path__ + "static/media/download-on-the-apple-store.2928664f.svg";